// ============================================================
// Document Management System (DMS) — Access Rights
// Range: 6001–6099
// ============================================================

export const DMS_ACCESS_RIGHTS = {

  //#region DASHBOARDS
  DMS_DASHBOARD:                                        6001,
  //#endregion

};